import { render, staticRenderFns } from "./bch_en_chn.vue?vue&type=template&id=6e352729&"
import script from "./bch_en_chn.vue?vue&type=script&lang=js&"
export * from "./bch_en_chn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports